import { MainLayout } from '../../../components/Modules/Layout';
import { useParams } from 'react-router-dom';
import { Col, Form, Row, Select, message } from 'antd';
import { STATUS } from 'constants/reponseStatus';
import { Content } from 'antd/es/layout/layout';
import { approvalDateOption, approvalOption } from 'mock/approve-mockup';
import ApprovalApi from 'apis/ApprovalApi';
import { useQuery } from 'react-query';
import { useFormik } from 'formik';
import { ICreateApprove, Iapprove } from 'interface/approve.interface';
import pageTitleStore from 'store/pageTitleStore';
import { useState } from 'react';
import handleError401 from 'utils/handleError401';
import Button from 'components/Button';

export default function EditApproval() {
  const [approval, SetApproval] = useState<any>();
  interface Iparam {
    id: string;
  }
  const { id } = useParams<Iparam>();

  const emptyValueResponse = 'không có dữ liệu';

  const {
    data: result,
    isLoading,
    refetch,
  } = useQuery(['getApproval'], () => ApprovalApi.getApproval(), {
    onSuccess: (response: any) => {
      if (response.status === STATUS.SUCCESS) {
        const app = response.data.filter((items: Iapprove) => {
          return items.id * 1 == +id;
        });
        SetApproval(app[0]);
        // setBreadcrumb([{ title: `Phê duyệt/ ${app[0].division?.name}` }]);
        setBreadcrumb([
          { title: <a href="/department-approval">Phê duyệt</a> },
          { title: <a>{app[0].division?.name}</a> },
        ]);
        setTitle(`${app[0].division?.name}`);
      }
    },
    onError: (error: any) => {
      if (error.response.data.status === 401) {
        handleError401();
      }
    },
  });

  const editItem = approval;

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      division_id: editItem?.division_id,
      pof_type_code: editItem?.pof_type?.pof_type_code,
      list_setting: [
        {
          approve_stage: 1,
          approve_level: editItem?.list_setting[0]?.approve_level,
          date_end: editItem?.list_setting[0]?.date_end,
        },
        {
          approve_stage: 2,
          approve_level: editItem?.list_setting[1]?.approve_level,
          date_end: editItem?.list_setting[1]?.date_end,
        },
        {
          approve_stage: 3,
          approve_level: editItem?.list_setting[2]?.approve_level,
          date_end: editItem?.list_setting[2]?.date_end,
        },
        {
          approve_stage: 4,
          approve_level: editItem?.list_setting[3]?.approve_level,
          date_end: editItem?.list_setting[3]?.date_end,
        },
      ],
      updated_by: '',
      created_by: '',
    },
    onSubmit: (values: ICreateApprove) => {
      const Values = formik.values;
      ApprovalApi.putApproval(Values)
        .then((res) => {
          message.success('chỉnh sửa thành công');
          setTimeout(() => {
            window.location.href = `/department-approval/detail/${id}`;
          }, 1000);
        })
        .catch((err) => {
          message.error('chỉnh sửa thất bại');
          console.log(err);
        });
    },
  });

  const handleChangeSelect = (name: string) => {
    return (value: any) => {
      formik.setFieldValue(name, value);
    };
  };

  const renderLeverOption = (listOption: Array<any>) => {
    return listOption.map((item) => {
      return (
        <Select.Option key={item.value} value={item.value}>
          {item.label}
        </Select.Option>
      );
    });
  };

  return (
    <MainLayout isLoading={isLoading}>
      <div className="mb-4 flex flex-col gap-4 pb-20 border-b-2 border-[#E1E3E6]">
        {/* header */}
        <Content>
          {' '}
          <Row>
            <Col span={12}>
              <p className="text-sm">
                Khối phát hành:{' '}
                <span className="font-bold ml-4">
                  {editItem?.division?.name}
                </span>
              </p>
            </Col>
            <Col span={12}>
              <p className="text-sm">
                Danh mục:{' '}
                <span className="font-bold ml-4">
                  {editItem?.pof_type?.pof_type_name}
                </span>
              </p>
            </Col>
          </Row>
        </Content>

        {/* Phát hành danh mục */}
        <Content>
          <div className="mb-4">
            <p className="text-base font-bold">1. Phát hành danh mục</p>
          </div>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={12}>
              <Form layout="vertical">
                <Form.Item label="Cấp phê duyệt">
                  <Select
                    defaultValue={'level1'}
                    onChange={handleChangeSelect(
                      'list_setting[0].approve_level'
                    )}
                  >
                    <Select.Option value="level1">
                      {formik.values.list_setting[0]?.approve_level
                        ? formik.values.list_setting[0]?.approve_level
                        : emptyValueResponse}{' '}
                      cấp
                    </Select.Option>
                    {renderLeverOption(approvalOption)}
                  </Select>
                </Form.Item>
              </Form>
            </Col>
            <Col className="" span={12}>
              <Form layout="vertical">
                <Form.Item label="Thời gian phê duyệt">
                  <Select
                    defaultValue={'date1'}
                    onChange={handleChangeSelect('list_setting[0].date_end')}
                  >
                    <Select.Option value="date1">
                      {formik.initialValues.list_setting[0]?.date_end
                        ? formik.initialValues.list_setting[0]?.date_end
                        : emptyValueResponse}{' '}
                      ngày
                    </Select.Option>
                    {renderLeverOption(approvalDateOption)}
                  </Select>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Content>

        {/* Chi nhánh đăng kí mẫu */}
        {/* <Content>
          <div className="mb-4">
            <p className="text-base font-bold">2. Phân bố chi nhánh</p>
          </div>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={12}>
              <Form layout="vertical">
                <Form.Item name="plantCode" label="Cấp phê duyệt">
                  <Select
                    defaultValue={'level2'}
                    onChange={handleChangeSelect(
                      'list_setting[1].approve_level'
                    )}
                  >
                    <Select.Option value="level2">
                      {formik.values.list_setting[1]?.approve_level
                        ? formik.values.list_setting[1]?.approve_level
                        : emptyValueResponse}{' '}
                      cấp
                    </Select.Option>
                    {renderLeverOption(approvalOption)}
                  </Select>
                </Form.Item>
              </Form>
            </Col>
            <Col className="" span={12}>
              <Form layout="vertical">
                <Form.Item name="plantCode" label="Thời gian phê duyệt">
                  <Select
                    defaultValue={'date2'}
                    onChange={handleChangeSelect('list_setting[1].date_end')}
                  >
                    <Select.Option value="date2">
                      {formik.initialValues.list_setting[1]?.date_end
                        ? formik.initialValues.list_setting[1]?.date_end
                        : emptyValueResponse}{' '}
                      ngày
                    </Select.Option>
                    {renderLeverOption(approvalDateOption)}
                  </Select>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Content> */}

        {/* Đăng ký giỏ hàng danh mục */}
        <Content>
          <div className="mb-4">
            <p className="text-base font-bold">2. Phân bố cửa hàng</p>
          </div>

          <div className="border-b-2 border-dashed">
            <div className="mb-4">
              <p className="text-base font-bold">
                A. Chi nhánh (chỉ phê duyệt đơn thuộc chi nhánh)
              </p>
            </div>

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={12}>
                <Form layout="vertical">
                  <Form.Item name="plantCode" label="Cấp phê duyệt">
                    <Select
                      defaultValue={'level3'}
                      onChange={handleChangeSelect(
                        'list_setting[2].approve_level'
                      )}
                    >
                      <Select.Option value="level3">
                        {formik.values.list_setting[2]?.approve_level
                          ? formik.values.list_setting[2]?.approve_level
                          : emptyValueResponse}{' '}
                        cấp
                      </Select.Option>
                      {renderLeverOption(approvalOption)}
                    </Select>
                  </Form.Item>
                </Form>
              </Col>
              <Col className="" span={12}>
                <Form layout="vertical">
                  <Form.Item name="plantCode" label="Thời gian phê duyệt">
                    <Select
                      defaultValue={'date3'}
                      onChange={handleChangeSelect('list_setting[2].date_end')}
                    >
                      <Select.Option value="date3">
                        {formik.initialValues.list_setting[2]?.date_end
                          ? formik.initialValues.list_setting[2]?.date_end
                          : emptyValueResponse}{' '}
                        ngày
                      </Select.Option>
                      {renderLeverOption(approvalDateOption)}
                    </Select>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </div>
          <div className="mt-4">
            <div className="mb-4">
              <p className="text-base font-bold">B. Hội sở</p>
            </div>

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={12}>
                <Form layout="vertical">
                  <Form.Item label="Cấp phê duyệt">
                    <Select
                      defaultValue={'level4'}
                      onChange={handleChangeSelect(
                        'list_setting[3].approve_level'
                      )}
                    >
                      <Select.Option value="level4">
                        {formik.values.list_setting[3]?.approve_level
                          ? formik.values.list_setting[3]?.approve_level
                          : emptyValueResponse}{' '}
                        cấp
                      </Select.Option>
                      {renderLeverOption(approvalOption)}
                    </Select>
                  </Form.Item>
                </Form>
              </Col>
              <Col className="" span={12}>
                <Form layout="vertical">
                  <Form.Item name="plantCode" label="Thời gian phê duyệt">
                    <Select
                      defaultValue={'date4'}
                      onChange={handleChangeSelect('list_setting[3].date_end')}
                    >
                      <Select.Option value="date4">
                        {formik.initialValues.list_setting[3]?.date_end
                          ? formik.initialValues.list_setting[3]?.date_end
                          : emptyValueResponse}{' '}
                        ngày
                      </Select.Option>
                      {renderLeverOption(approvalDateOption)}
                    </Select>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </div>
        </Content>
      </div>
      <div>
        <Form onSubmitCapture={formik.handleSubmit}>
          {' '}
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="end"
            className="mb-1"
          >
            <Col span={12} className="flex justify-end">
              <Button type="submit">Chỉnh sửa</Button>
            </Col>
          </Row>
        </Form>
      </div>
    </MainLayout>
  );
}
